export default __webpack_public_path__ + "images/emergency.9c5e7055fd7e22896aede2900a439dff.svg";